import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getCorporate = async (id: string) => {
  try {
    return await get<ApiResponse<any>>(`/corporate/details/${id}`).then((res) => {
      if (res.success === true) {         
        return res;                 
      }
      return null;
    });
  } catch (e: any) {
    HandleApiError(e);
  }
};

